<template>
    <header class="cabecera">
      <div class="contenedor-logo">
        <router-link :to="{ name: 'p1' }">
          <img src="@/assets/images/logo_blanco.png" alt="LOGO KIA" class="logo-main">
        </router-link>
      </div>
      <div class="linea-divisoria"></div>
    </header>
  </template>
  
  <script>
  export default {
    name: "Header"
  };
  </script>
  
  <style scoped>
  /* Header con fondo transparente */
  .cabecera {
    background-color: transparent;
    padding: 10px 0;
    text-align: center;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;
  }
  
  /* Contenedor del logo */
  .contenedor-logo {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Imagen del logo */
  .logo-main {
    max-height: 30px;
    width: auto;
  }
  
  /* Línea divisoria debajo del logo */
  .linea-divisoria {
    width: 100%;
    max-width: 100%;
    height: 1px;
    background-color: white; /* Puedes cambiar el color si es necesario */
    margin: 10px auto 0;
    opacity: 0.8; /* Transparencia opcional */
  }
  
  /* Responsivo */
  @media (max-width: 480px) {
    .logo-main {
      max-height: 30px;
    }
  
    .linea-divisoria {
      width: 100%;
    }
  }
  </style>
  